module.exports = __webpack_public_path__ + "static/media/marketing.73475e2c.png";